export const GET_DATA_INTEGRATIONS = 'GET_DATA_INTEGRATIONS'
export const GET_DATA_INTEGRATIONS_FAILED = 'GET_DATA_INTEGRATIONS_FAILED'
export const GET_DATA_INTEGRATIONS_SUCCEEDED = 'GET_DATA_INTEGRATIONS_SUCCEEDED'

export const SYNC_DATA_INTEGRATION = 'SYNC_DATA_INTEGRATION'
export const SYNC_DATA_INTEGRATION_FAILED = 'SYNC_DATA_INTEGRATION_FAILED'
export const SYNC_DATA_INTEGRATION_SUCCEEDED = 'SYNC_DATA_INTEGRATION_SUCCEEDED'

export const CONNECT_DATA_INTEGRATION = 'CONNECT_DATA_INTEGRATION'
export const CONNECT_DATA_INTEGRATION_FAILED = 'CONNECT_DATA_INTEGRATION_FAILED'
export const CONNECT_DATA_INTEGRATION_SUCCEEDED = 'CONNECT_DATA_INTEGRATION_SUCCEEDED'

export const DISCONNECT_DATA_INTEGRATION = 'DISCONNECT_DATA_INTEGRATION'
export const DISCONNECT_DATA_INTEGRATION_FAILED = 'DISCONNECT_DATA_INTEGRATION_FAILED'
export const DISCONNECT_DATA_INTEGRATION_SUCCEEDED = 'DISCONNECT_DATA_INTEGRATION_SUCCEEDED'

export const GET_QUICKBOOK_CONNECTION = 'GET_QUICKBOOK_CONNECTION'
export const GET_QUICKBOOK_CONNECTION_FAILED = 'GET_QUICKBOOK_CONNECTION_FAILED'
export const GET_QUICKBOOK_CONNECTION_SUCCEEDED = 'GET_QUICKBOOK_CONNECTION_SUCCEEDED'

export const SYNC_EXPORT_DATA = 'SYNC_EXPORT_DATA'
export const SYNC_EXPORT_DATA_FAILED = 'SYNC_EXPORT_DATA_FAILED'
export const SYNC_EXPORT_DATA_SUCCEEDED = 'SYNC_EXPORT_DATA_SUCCEEDED'
export const SYNC_EXPORT_NO_RECORDS_SELECTED = 'SYNC_EXPORT_NO_RECORDS_SELECTED'
